import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import HeaderComponent from "@components/common/Header/Header";
import BackIcon from "@styles/all-images/icons/back-button.svg";
import PlusIcon from "@styles/all-images/icons/plus.svg";
import CheckBlueIcon from "@styles/all-images/icons/checkblue.svg";
import CloseRedIcon from "@styles/all-images/icons/closered.svg";
import UserIcon from "@styles/all-images/icons/bg-user.svg";
import TierConfigurationRejectionReason from "./TierConfigurationRejectionReason";
import CustomTable from "@/components/common/table/CustomTable";

const ClientOnBoardingModule = () => {
  const tierData = [
    {
      supertrader: "Mark Robinson",
      emailAddress: "mark@gmail.com",
      contactNumber: "0712345678",
      requestOn: "03/12/2024 09:30",
      rejectOn: "-",
      actions: (
        <div>
          <button>
            <img src={CheckBlueIcon} alt="Approve" className="tw-w-5 tw-h-5" />
          </button>
          <button>
            <img src={CloseRedIcon} alt="Reject" className="tw-w-5 tw-h-5" />
          </button>
        </div>
      ),
    },
    {
      supertrader: "Patricia Wilson",
      emailAddress: "patricia@gmail.com",
      contactNumber: "0712345678",
      requestOn: "03/12/2024 08:50",
      rejectOn: "Anele Ndlovu",
      actions: (
        <div>
          <button>
            <img src={CheckBlueIcon} alt="Approve" className="tw-w-5 tw-h-5" />
          </button>
          <button>
            <img src={CloseRedIcon} alt="Reject" className="tw-w-5 tw-h-5" />
          </button>
        </div>
      ),
    },
    {
      supertrader: "Sophia Turner",
      emailAddress: "sophia@gmail.com",
      contactNumber: "0712345678",
      requestOn: "02/12/2024 18:15",
      rejectOn: "John Doe",
      actions: (
        <div>
          <button>
            <img src={CheckBlueIcon} alt="Approve" className="tw-w-5 tw-h-5" />
          </button>
          <button>
            <img src={CloseRedIcon} alt="Reject" className="tw-w-5 tw-h-5" />
          </button>
        </div>
      ),
    },
    {
      supertrader: "James Taylor",
      emailAddress: "james@gmail.com",
      contactNumber: "0712345678",
      requestOn: "02/12/2024 14:40",
      rejectOn: "-",
      actions: (
        <div>
          <button>
            <img src={CheckBlueIcon} alt="Approve" className="tw-w-5 tw-h-5" />
          </button>
          <button>
            <img src={CloseRedIcon} alt="Reject" className="tw-w-5 tw-h-5" />
          </button>
        </div>
      ),
    },
    {
      supertrader: "Mason Wright",
      tsDocument: "Terms Sheet Document 5",
      createdBy: "Zanele Masinga",
      requestOn: "02/12/2024 10:25",
      rejectOn: "-",
      actions: (
        <div>
          <button>
            <img src={CheckBlueIcon} alt="Approve" className="tw-w-5 tw-h-5" />
          </button>
          <button>
            <img src={CloseRedIcon} alt="Reject" className="tw-w-5 tw-h-5" />
          </button>
        </div>
      ),
    },
  ];

  const [isStaffModalOpen, setIsStaffModalOpen] = useState(false);
  const [isRejectionModalOpen, setIsRejectionModalOpen] = useState(false);

  const handleOpenStaffModal = () => {
    setIsStaffModalOpen(true);
  };
  const handleOpenRejectionModal = () => {
    setIsRejectionModalOpen(true);
  };

  const handleCloseRejectionModal = () => {
    setIsRejectionModalOpen(false);
  };

  const handleRejectionSubmit = () => {
    setIsRejectionModalOpen(false);
  };

  const navigate = useNavigate();

  const [forceRefresh, setForceRefresh] = useState<boolean>(false);

  const handleSetForceRefresh = (
    value: boolean | ((prev: boolean) => boolean),
  ) => {
    if (typeof value === "function") {
      setForceRefresh((prev) => value(prev));
    } else {
      setForceRefresh(value);
    }
  };

  const fetchData = async (filters: any) => {
    // Your logic to fetch data
    return {
      data: {
        data: tierData,
        meta: {
          count: tierData.length,
          page: 1,
          limit: 5,
        },
      },
    };
  };

  return (
    <div className="tw-relative">
      <HeaderComponent />
      <div className="tw-fixed tw-h-[68px] tw-top-[80px] tw-w-full tw-z-10">
        <div className="tw-px-8 tw-py-4 tw-bg-white tw-border-b tw-border-[#E9EAEB]">
          <div className="tw-flex tw-justify-between tw-items-center">
            <div className="tw-flex tw-items-center">
              <a href="/">
                <img src={BackIcon} alt="Back Icon" />
              </a>
              <h1 className="tw-text-[22px] tw-ml-4 tw-font-semibold tw-text-[#232323]">
                Client Profiles
              </h1>
            </div>
            <div className="tw-flex tw-items-center tw-gap-4">
              <button
                onClick={handleOpenStaffModal}
                className="tw-bg-blue-600 hover:tw-bg-blue-700 tw-flex tw-items-center tw-gap-2 tw-text-white tw-rounded-md tw-px-4 tw-py-2 primary-custom-button"
              >
                <img src={PlusIcon} alt="Plus Icon" className="tw-w-5 tw-h-5" />
                Add Client
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="tw-p-6 tw-mt-[147px]">
        <div className="tw-border tw-bg-white tw-rounded-lg tw-mt-2">
          <CustomTable
            columns={[
              {
                header: "Client Name",
                sortable: true,
                sortKey: "supertrader",
                accessor: (row: any) => (
                  <div className="tw-flex tw-items-center tw-gap-2">
                    <img src={UserIcon} alt="User Icon" />
                    <span className="tw-text-sm tw-font-medium tw-text-[#181D27]">
                      {row.supertrader}
                    </span>
                  </div>
                ),
              },
              {
                header: "Email Address",
                sortable: true,
                sortKey: "emailAddress",
                accessor: "emailAddress",
              },
              {
                header: "Contact Number",
                sortable: true,
                sortKey: "contactNumber",
                accessor: "contactNumber",
              },
              {
                header: "Request On",
                sortable: true,
                sortKey: "requestOn",
                accessor: "requestOn",
              },
              {
                header: "Reject On",
                sortable: true,
                sortKey: "rejectOn",
                accessor: "rejectOn",
              },
              {
                header: "Actions",
                accessor: (row: any) => (
                  <div className="tw-flex tw-items-center tw-gap-5">
                    <button>
                      <img
                        src={CheckBlueIcon}
                        alt="Lock Icon"
                        className="tw-w-5 tw-h-5"
                      />
                    </button>
                    <button
                      onClick={handleOpenRejectionModal}
                      className="tw-ml-4"
                    >
                      <img
                        src={CloseRedIcon}
                        alt="Lock Icon"
                        className="tw-w-5 tw-h-5"
                      />
                    </button>
                  </div>
                ),
              },
            ]}
            forceRefresh={forceRefresh}
            setForceRefresh={handleSetForceRefresh}
            fetchData={fetchData}
          />
        </div>

        {/* Rejection Modal */}

        <div>
          {isRejectionModalOpen && (
            <TierConfigurationRejectionReason
              onClose={handleCloseRejectionModal}
              onSubmit={handleRejectionSubmit}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ClientOnBoardingModule;
